<app-ng-business-hero
    overTitle="Nutrigenic for business"
    title="OFFICE FOOD DELIVERY<br/> THAT SUPPORTS<br/> EMPLOYEE WELL-BEING"
    subtitle="Our corporate meal delivery service is designed for UK businesses of all sizes, offering fresh, ready-made meals that are nutritious, convenient, and cost-effective. Whether you’re a small team or a large workforce, NutriGenic makes it easy to invest in your employees’ health and satisfaction."
    [image]="{
        desktop: 'assets/images/ng-for-business/bg-ng-banner-business-lg.jpg',
        tablet: 'assets/images/ng-for-business/bg-ng-banner-business-md.jpg',
        mobile: 'assets/images/ng-for-business/bg-ng-banner-business-sm.jpg',
        alt: 'Happy team enjoying NutriGenic meals',
    }"
/>

<app-ng-business-meal-solution
    *ngIf="(windowWidth$ | async)! > 1279"
    title="LOOKING FOR A WORKPLACE <br /> MEAL SOLUTION THAT WORKS?"
    description="Promote a healthier lifestyle, improve productivity, and show your team that their well-being matters. NutriGenic’s office meal delivery service takes the hassle out of lunch: no meal prep, no queues, no guesswork. Just fresh, chef-prepared meals delivered directly to your workplace, ready to eat in minutes."
/>

<app-ng-business-feature-grid
  title="WHY NUTRIGENIC?"
  subtitle="We believe a well-fed team is a happier, more productive team. Our meals are:"
  [features]="[
    {
      icon: 'assets/images/icons/natural-food-icon.svg',
      alt: 'Natural Food icon',
      text: 'Fresh, never frozen',
    },
    {
      icon: 'assets/images/icons/organic-food-icon.svg',
      alt: 'Organic Food icon',
      text: 'Made with zero artificial ingredients or preservatives',
    },
    {
      icon: 'assets/images/icons/chef-icon.svg',
      alt: 'Chef icon',
      text: 'Prepared by chefs and reviewed by in-house nutritionists',
    },
    {
      icon: 'assets/images/icons/delivery-track-icon.svg',
      alt: 'Delivery icon',
      text: 'Delivered twice weekly to ensure peak freshness',
    },
  ]"
/>

<app-ng-business-meal-solution
    *ngIf="(windowWidth$ | async)! < 1280"
    title="LOOKING FOR A WORKPLACE <br /> MEAL SOLUTION THAT WORKS?"
    description="Promote a healthier lifestyle, improve productivity, and show your team that their well-being matters. NutriGenic’s office meal delivery service takes the hassle out of lunch: no meal prep, no queues, no guesswork. Just fresh, chef-prepared meals delivered directly to your workplace, ready to eat in minutes."
/>

<app-ng-business-alt-solutions
  title="A BETTER ALTERNATIVE TO TAKEAWAY,<br class='d-xl-none'/> CATERING & DINING OUT"
  [cards]="[
    {
      image: 'assets/images/ng-for-business/takeaway.jpg',
      alt: 'Takeaway food',
      title: 'Takeaways are costly and often lack nutritional balance',
    },
    {
      image: 'assets/images/ng-for-business/dining-out.jpg',
      alt: 'Dining out',
      title: 'Dining out takes time and adds up fast',
    },
    {
      image: 'assets/images/ng-for-business/catering.jpg',
      alt: 'Dirty dishes',
      title: 'Catering is limited, and setup/cleanup is a hassle',
    },
  ]"
  note="With NutriGenic, your team gets the convenience of ready-to-eat meals with the quality of a freshly cooked lunch — no compromises."
/>

<app-ng-business-arrow-divider />

<app-ng-business-meal-diet
  title='MEALS FOR EVERY DIET AND GOAL'
  subtitle='We offer a rotating menu of balanced, nutrient-rich meals suitable for a variety of dietary needs and preferences:'
  [cards]="[
      {
        image: 'assets/images/ng-for-business/protein-plus.jpg',
        alt: 'Protein Plus',
        title: 'Protein Plus',
        description: '40–50g of protein per meal',
      },
      {
        image: 'assets/images/ng-for-business/calorie-smart.jpg',
        alt: 'Calorie Smart',
        title: 'Calorie Smart',
        description: 'Between 430–550 kcal',
      },
      {
        image: 'assets/images/ng-for-business/vegan-veggie.jpg',
        alt: 'Vegan & Veggie',
        title: 'Vegan & Veggie',
        description: 'Wholesome, plant-forward meals',
      },
      {
        image: 'assets/images/ng-for-business/larger-meals.jpg',
        alt: 'Larger Meals',
        title: 'Larger Meals',
        description: 'For those who need a little more',
      },
    ]"
    note="All meals are made with whole food ingredients that support long-term health and sustained energy throughout the workday."
    ctaText="Get in touch"
/>

<div class="card p-0">
  <div class="loghi-wrapper">
    <h3 class="p-title-2 pt-40 pb-40">
      As Seen In
    </h3>
    <app-images-loghi />
  </div>

  <section class="how-it-works">
      <app-process-steps
        title="How it works"
        [steps]="[
          {
            title: 'Get in touch',
            description: 'Fill out a quick form or contact our team directly. We’ll learn about your team’s needs and goals.',
            image: 'assets/images/ng-for-business/get-in-touch.jpg',
            alt: 'Step 1 - Get in Touch',
          },
          {
            title: 'Build a Plan That Works',
            description: 'We’ll tailor a corporate meal solution that fits your schedule, preferences, and budget.',
            image: 'assets/images/ng-for-business/build-a-plan.jpg',
            alt: 'Step 2 - Build a Plan',
          },
          {
            title: 'Let Us Handle the Rest',
            description: 'From cooking to delivery, we take care of everything. All your team has to do is heat, eat, and enjoy.',
            image: 'assets/images/ng-for-business/handle-rest.jpg',
            alt: 'Step 3 - Let Us Handle the Rest',
          },
        ]"
      />
  </section>

  <app-ng-business-arrow-divider />

  <app-ng-business-contact-section />
</div>
